export default __webpack_public_path__ + "static/pdp--product-2-4ac58bb828edb8e3aa60789e80e9d116.jpg";